export const Input = ({ ...props }) => (
  <input className="w-full px-4 py-2 border rounded" {...props} />
);
